import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";
import Button from "../../../../../../../ui/Button";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import MuiDialogContent from "@material-ui/core/DialogContent";
import MuiDialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import Typography from "@material-ui/core/Typography";
import TextField from "../../../../../../../ui/TextField";
import { FormControlLabel, Checkbox } from "@material-ui/core";

const styles = theme => ({
  root: {
    margin: 0,
    padding: theme.spacing(2)
  },
  typography: {
    color: "#778899"
  },
  closeButton: {
    position: "absolute",
    right: 4,
    top: 4,
    color: theme.palette.grey[500]
  },
  dialog: {
    width: "476px"
  },
  checkbox: {
    "& > .MuiCheckbox-colorPrimary.Mui-checked": {
      color: "rgba(0, 127, 189, 0.7);"
    }
  },
  label: {
    fontSize: 10
  },
  requestbody: {
    '& .MuiGrid-container':{
      marginBottom: 16
    }
  },
  heading: {
    fontSize: 14,
    lineHeight: "18px",
    display: "flex",
    alignItems: "center",
    color: "#000000",
    margin: "8px 0"
  },
  checkBoxLabel: {
    fontSize: 12
  },
  sendEmail: {
    height: 20,
    borderRadius: 10,
    color: "#FFF",
    background: "rgba(48, 73, 103, 0.8)",
    fontSize: 12,
    marginLeft: 8,
    paddingRight: 8,
    paddingLeft: 8,
    paddingTop: 2,
    display: "inline-block",
    justifyContent: "center",
    cursor: "default"
  }
});

const DialogTitle = withStyles(styles)(props => {
  const { children, classes, onClose, ...other } = props;
  return (
    <MuiDialogTitle disableTypography className={classes.root} {...other}>
      <Typography className={classes.typography}>{children}</Typography>
      {onClose ? (
        <IconButton
          aria-label="close"
          className={classes.closeButton}
          onClick={onClose}
        >
          <CloseIcon />
        </IconButton>
      ) : null}
    </MuiDialogTitle>
  );
});

const DialogContent = withStyles(theme => ({
  root: {
    padding: theme.spacing(2),
    borderTop: "1px solid rgba(0, 0, 0, 0.12)"
  }
}))(MuiDialogContent);

const DialogActions = withStyles(theme => ({
  root: {
    margin: 0,
    padding: "16px",
    "& > button:first-of-type": {
      marginRight: 4
    }
  }
}))(MuiDialogActions);

const DeclineRequestModal = ({
  requestId,
  accountEmail,
  open,
  handleClose,
  handleReload,
  handleDecline,
  classes,
  isDecliningRequest,
  declinedRequest
}) => {
  const [comment, setComment] = React.useState("");
  const [isSendEmail, setIsSendEmail] = React.useState(true);

  const onConfirm = () => {
    handleDecline(requestId, comment);
  };

  const onClose = () => {
    handleClose();
  };

  React.useEffect(() => {
    if (declinedRequest && declinedRequest.success) {
      setComment("");
      setIsSendEmail(false);
      handleClose();
      handleReload();
    }
  }, [declinedRequest]);

  return (
    <div>
      <Dialog
        onClose={onClose}
        aria-labelledby="customized-dialog-title"
        open={open}
        PaperProps={{
          className: classes.dialog
        }}
      >
        <DialogTitle onClose={onClose}>Отклонение заявки</DialogTitle>
        <DialogContent>
          {accountEmail &&
          <div className={classes.requestbody}>
            <FormControlLabel
                control={
                  <Checkbox
                    onChange={(_, val) => setIsSendEmail(val)}
                    value="checked"
                    checked={isSendEmail}
                    color="primary"
                  />
                }
                label={
                  <span className={classes.checkBoxLabel}>
                    Отправить уведомление об отклонении заявки на указанный email
                    <span className={classes.sendEmail}>{accountEmail}</span>
                  </span>
                }
                classes={{
                  label: classes.label,
                  root: classes.checkbox
                }}
            />

            {isSendEmail &&
            <TextField
              value={comment}
              onChange={e => setComment(e.target.value)}
              label="Сопроводительное сообщение"
            />}
          </div>
        }
        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose}>Отмена</Button>
          <Button
            loading={isDecliningRequest}
            disabled={isDecliningRequest}
            onClick={() => onConfirm()}
            color="pink"
          >
            Отклонить
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

export default withStyles(styles)(DeclineRequestModal);
